module.exports = __webpack_public_path__ + "static/media/GothamBook.b54724f5.ttf";